// src/components/ProtectedRoute.js
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ allowedRoles = [] }) => {
    const { currentUser, loading, hasAnyRole } = useAuth();

    if (loading) {
        return (
            <div className="flex items-center justify-center min-h-screen">
                <div className="animate-spin rounded-full h-10 w-10 border-t-2 border-b-2 border-primary-600"></div>
            </div>
        );
    }

    // Check if the user is authenticated
    if (!currentUser) {
        return <Navigate to="/login" replace />;
    }

    // If no roles are specified, allow access for any authenticated user
    if (allowedRoles.length === 0) {
        return <Outlet />;
    }

    // Check if the user has any of the allowed roles
    if (hasAnyRole(allowedRoles)) {
        return <Outlet />;
    }

    // Redirect to unauthorized page if user doesn't have the required roles
    return <Navigate to="/unauthorized" replace />;
};

export default ProtectedRoute;
